import { ILabelValuePair } from '@whitelabel/helpers/types';
import stateList from './state.json';
import { IManualInputAddress } from './types';

export const extractCity = (components: any) => {
  const locality = components.find(({ types }: any) => types.includes('locality'));
  if (locality) return locality.long_name;
  const postalTown = components.find(({ types }: any) => types.includes('postal_town'));
  if (postalTown) return postalTown.long_name;
  const neighborhood = components.find(({ types }: any) => types.includes('neighborhood'));
  if (neighborhood) return neighborhood.long_name;
  return null;
};

export const getStatesOfCountry = (countryCode: string, locale?: string | string[]): ILabelValuePair[] => {
  if (!countryCode) return [];
  const states = stateList.filter((value) => value.countryCode === countryCode);
  return states
    .map(({ name, isoCode }) => ({ label: name, value: isoCode }))
    .sort((a, b) => a.label.localeCompare(b.label, locale));
};

export const manualAddressInitialValues = {
  address1: '',
  address2: '',
  country: '',
  region: '',
  city: '',
  postcode: '',
};

export const manualToGeoSuggestValue = (addressObj?: IManualInputAddress) => {
  if (!addressObj?.address1) {
    return;
  }
  return `${addressObj.address1}, ${addressObj.address2 ? `${addressObj.address2}, ` : ''}${
    addressObj.city ? `${addressObj.city}, ` : ''
  }${addressObj.region ? `${addressObj.region}, ` : ''}${addressObj.postcode ? `${addressObj.postcode}, ` : ''}${
    addressObj.country ?? ''
  }`;
};

export const getReactSelectValue = (value: string, options: ILabelValuePair[]): ILabelValuePair | null =>
  // result cannot be undefined, otherwise react-select will show previous value
  options.filter((option) => option.value === value)?.[0] ?? null;
